import { useDispatch, useSelector } from 'react-redux'

import { sendFileMessage } from 'app/redux/messages/messages.actions'
import { Attachment, FileUploadIcon, ImageUploadIcon } from 'app/components/icons'
import './fileUpload.scss'

const getTexts = ({ widgetData }) => widgetData.widgetInfo.languageInfo.texts

const FileUpload = () => {
  const texts = useSelector(getTexts)
  const dispatch = useDispatch()

  const handleClickSendFileMessage = (e) => dispatch(sendFileMessage(e.target.files[0]))

  return (
    <div className="chat_file_upload_wrapper">
      <input className="chat_file_input" id="any-files" type="file" onChange={handleClickSendFileMessage} />

      <input
        className="chat_file_input"
        id="image-files"
        type="file"
        onChange={handleClickSendFileMessage}
        accept={'image/*'}
      />

      <div className="chat_file_input_lable">
        <div className="upload_file_options_container">
          <div className="upload_file_options_wrapper">
            <label className="upload_file_option" htmlFor="any-files">
              <FileUploadIcon className="upload_file_icon" color="#667085" />
              <span className="upload_file_option_text">{texts.uploadFile}</span>
            </label>

            <label htmlFor="image-files" className="upload_file_option">
              <ImageUploadIcon className="upload_image_icon" color="#667085" />

              <span className="upload_file_option_text">{texts.uploadImage}</span>
            </label>
          </div>
        </div>

        <Attachment className="chat_file_input_icon" color="#000" />
      </div>
    </div>
  )
}

export default FileUpload
